module.exports = __webpack_public_path__ + "static/media/trialExpired.d74bfca8.png";